import { useEffect } from 'react';
import { env } from '@/config/env';
import { activateDevToolsProtection } from '@/lib/devtools-protection';

export function useDevToolsProtection(): void {
  useEffect(() => {
    if (!env.DEVTOOLS_PROTECTION_ENABLED) return;
    return activateDevToolsProtection();
  }, []);
}
